<form [formGroup]="formName">
  <mat-slide-toggle class="example-margin" [checked]="field.value" [formControlName]="field.filterKey">
    {{field.label ? field.label : ''}}
  </mat-slide-toggle>
</form>
